import {
  apiRecursive,
  ApiSmpAccountCredentials,
  IApiSmpAccountCredential,
  IApiSmpAccountCredentialListReq,
  IApiSmpAccountCredentialRetrieveReq,
} from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "smp.account_credentials";
const KEY_LIST = "smp.account_credentials.list";

export const useSmpAccountCredential = (options: {
  req: IApiSmpAccountCredentialRetrieveReq;
  useQueryOptions?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiSmpAccountCredentials.retrieve>>
    >,
    "queryFn" | "queryKey"
  >;
}) => {
  const { data: accountCredential, isLoading: isAccountCredentialLoading } =
    useQuery(
      [KEY, options.req],
      () => ApiSmpAccountCredentials.retrieve(options.req),
      options.useQueryOptions,
    );
  return { accountCredential, isAccountCredentialLoading };
};

useSmpAccountCredential.KEY = KEY;

export const useSmpAccountCredentialList = (options?: {
  req?: IApiSmpAccountCredentialListReq;
  useQueryOptions?: Omit<
    UseQueryOptions<IApiSmpAccountCredential[]>,
    "queryFn" | "queryKey"
  >;
}) => {
  const {
    data: accountCredentialList,
    isLoading: isAccountCredentialListLoading,
  } = useQuery(
    [KEY_LIST, options?.req],
    () => apiRecursive(ApiSmpAccountCredentials.list, [options?.req]),
    options?.useQueryOptions,
  );
  return { accountCredentialList, isAccountCredentialListLoading };
};

useSmpAccountCredentialList.KEY = KEY_LIST;
